import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { TreeProvider } from './treeContext';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {boolean} [disabled]
 * @prop {boolean} [defaultExpandAll]
 * @prop {boolean} [expandAll]
 * @prop {boolean} [showLines]
 * @prop {string} [className]
 */
/**
 * @param {Props} props
 */
const MotifTree = ({ children, disabled = false, defaultExpandAll = false, expandAll = false, showLines = false, className = '' }) => {
  const classes = classNames({
    'motif-tree': true,
    'motif-tree-nodes': true,
    [className]: true
  });

  return (
    <TreeProvider value={{ disabled, defaultExpandAll, expandAll, showLines }}>
      <ul className={classes} data-motif-tree>{children}</ul>
    </TreeProvider>
  );
};

MotifTree.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  defaultExpandAll: PropTypes.bool,
  expandAll: PropTypes.bool,
  showLines: PropTypes.bool,
  className: PropTypes.string
};

export { MotifTree };
